import Api from 'api/api';
import { queryKeys } from 'api/queryKeys';

export const userRegistryNotifications = {
  queryKey: queryKeys.userRegistryNotifications,
  queryFn: Api.getRegistryNotifications,
};
